import FieldsModel from '@/Models/Contracts/FieldsModel';
import i18n from '@/Plugins/i18n';
export default class ProfitAndLoss extends FieldsModel {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(...props) {
        super(...props);
        this.type = 'profit_and_loss';
    }
    getType() {
        return 'profit_and_loss';
    }
    get header() {
        return `
            <span class="grid gap-2">
                <span>${i18n.t('general.manual_profit_and_loss')}</span>
                <span>${moment(this.date).format('MMMM YYYY')}</span>
            </span>
        `;
    }
}
